/**
 * @generated SignedSource<<a38e7252ca772f10ce6144e3c1cbf6cf>>
 * @relayHash 96bb2eca78918614ce294099276a0f50
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID f9c9105d2e411f6df4cdf09defb95d3a63d1676d90c0f515e5eb728c283e1916

import type { ConcreteRequest, Mutation } from 'relay-runtime';
export type JiraDevOpsIssuePanelBannerType = "ISSUE_KEY_ONBOARDING" | "%future added value";
export type onboardingMessageJiraDevstatusUserOptOutOfNoDataStateMutation$variables = {
  bannerType: JiraDevOpsIssuePanelBannerType;
  issueId: string;
};
export type onboardingMessageJiraDevstatusUserOptOutOfNoDataStateMutation$data = {
  readonly jira: {
    readonly devOps: {
      readonly dismissDevOpsIssuePanelBanner: {
        readonly errors: ReadonlyArray<{
          readonly extensions: {
            readonly __typename: "GenericMutationErrorExtension";
            readonly statusCode: number | null | undefined;
          } | {
            // This will never be '%other', but we need some
            // value in case none of the concrete values match.
            readonly __typename: "%other";
          } | null | undefined;
          readonly message: string | null | undefined;
        }> | null | undefined;
        readonly success: boolean;
      } | null | undefined;
    } | null | undefined;
  } | null | undefined;
};
export type onboardingMessageJiraDevstatusUserOptOutOfNoDataStateMutation = {
  response: onboardingMessageJiraDevstatusUserOptOutOfNoDataStateMutation$data;
  variables: onboardingMessageJiraDevstatusUserOptOutOfNoDataStateMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "bannerType"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "issueId"
},
v2 = [
  {
    "fields": [
      {
        "kind": "Variable",
        "name": "bannerType",
        "variableName": "bannerType"
      },
      {
        "kind": "Variable",
        "name": "issueId",
        "variableName": "issueId"
      }
    ],
    "kind": "ObjectValue",
    "name": "input"
  }
],
v3 = {
  "kind": "ScalarField",
  "name": "success"
},
v4 = {
  "kind": "ScalarField",
  "name": "message"
},
v5 = {
  "kind": "ScalarField",
  "name": "__typename"
},
v6 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "statusCode"
    }
  ],
  "type": "GenericMutationErrorExtension"
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Fragment",
    "name": "onboardingMessageJiraDevstatusUserOptOutOfNoDataStateMutation",
    "selections": [
      {
        "concreteType": "JiraMutation",
        "kind": "LinkedField",
        "name": "jira",
        "plural": false,
        "selections": [
          {
            "concreteType": "JiraDevOpsMutation",
            "kind": "LinkedField",
            "name": "devOps",
            "plural": false,
            "selections": [
              {
                "args": (v2/*: any*/),
                "concreteType": "JiraDismissDevOpsIssuePanelBannerPayload",
                "kind": "LinkedField",
                "name": "dismissDevOpsIssuePanelBanner",
                "plural": false,
                "selections": [
                  (v3/*: any*/),
                  {
                    "concreteType": "MutationError",
                    "kind": "LinkedField",
                    "name": "errors",
                    "plural": true,
                    "selections": [
                      (v4/*: any*/),
                      {
                        "kind": "LinkedField",
                        "name": "extensions",
                        "plural": false,
                        "selections": [
                          (v5/*: any*/),
                          (v6/*: any*/)
                        ]
                      }
                    ]
                  }
                ]
              }
            ]
          }
        ]
      }
    ],
    "type": "Mutation"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "onboardingMessageJiraDevstatusUserOptOutOfNoDataStateMutation",
    "selections": [
      {
        "concreteType": "JiraMutation",
        "kind": "LinkedField",
        "name": "jira",
        "plural": false,
        "selections": [
          {
            "concreteType": "JiraDevOpsMutation",
            "kind": "LinkedField",
            "name": "devOps",
            "plural": false,
            "selections": [
              {
                "args": (v2/*: any*/),
                "concreteType": "JiraDismissDevOpsIssuePanelBannerPayload",
                "kind": "LinkedField",
                "name": "dismissDevOpsIssuePanelBanner",
                "plural": false,
                "selections": [
                  (v3/*: any*/),
                  {
                    "concreteType": "MutationError",
                    "kind": "LinkedField",
                    "name": "errors",
                    "plural": true,
                    "selections": [
                      (v4/*: any*/),
                      {
                        "kind": "LinkedField",
                        "name": "extensions",
                        "plural": false,
                        "selections": [
                          (v5/*: any*/),
                          (v6/*: any*/),
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              {
                                "kind": "ScalarField",
                                "name": "id"
                              }
                            ],
                            "type": "BulkMutationErrorExtension"
                          }
                        ]
                      }
                    ]
                  }
                ]
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "id": "f9c9105d2e411f6df4cdf09defb95d3a63d1676d90c0f515e5eb728c283e1916",
    "metadata": {},
    "name": "onboardingMessageJiraDevstatusUserOptOutOfNoDataStateMutation",
    "operationKind": "mutation",
    "text": null
  }
};
})();

(node as any).hash = "b1f05d6abb35abced8feaf2ccc8a39be";

export default node;
